import {
  SET_USER,
  SET_PANEL_OPEN,
  SET_PRODUCTS,
  UPDATE_PRODUCT,
  UPDATE_PRODUCT_DEPOT_INFOS,
  SET_PRODUCT_DEPOT_INFOS,
  SET_SUB_SUB_CATEGORIES,
  SET_DEPOTS,
  UPDATE_DEPOT,
  SET_QUOTES,
  UPDATE_QUOTE,
  REMOVE_QUOTE,
  UPDATE_INVOICE,
  SET_INVOICES,
  SET_PROFORMA_INVOICES,
  UPDATE_PROFORMA_INVOICE,
  SET_NOTIFICATIONS,
  UPDATE_NOTIFICATION,
  ADD_NOTIFICATION,
  ADD_PRODUCT,
  ADD_QUOTE,
  ADD_INVOICE,
  ADD_DEPOT,
  SET_PURCHASE_ORDERS,
  UPDATE_PURCHASE_ORDER,
  ADD_PURCHASE_ORDER,
  SET_PURCHASE_ORDER_STATUSES,
  SET_CREATE_PROGRAM_PROGRAM,
  CLEAR_CREATE_PROGRAM,
  ADD_CREATE_PROGRAM_LINE,
  UPDATE_CREATE_PROGRAM_LINE,
  REMOVE_CREATE_PROGRAM_LINE,
  MOVE_CREATE_PROGRAM_LINE_UP,
  MOVE_CREATE_PROGRAM_LINE_DOWN,
  SET_PROGRAMS_LIST,
  ADD_PROGRAM,
  UPDATE_PROGRAM,
  REMOVE_PROGRAM,
  SET_APPLICATIONS_LIST,
  ADD_APPLICATION,
  UPDATE_APPLICATION,
  SET_CURRENT_APPLICATION,
  RDW_ADD_WIDGET,
  RDW_REMOVE_WIDGET,
  RDW_SET_LAYOUT,
  RDW_UPDATE_SIZE,
  DF_SET_PRESET_RANGE,
  DF_SET_CUSTOM_RANGE,
  // Operating Costs
  SET_OPERATING_COSTS,
  ADD_OPERATING_COST,
  UPDATE_OPERATING_COST,
  REMOVE_OPERATING_COST,
  SET_PANEL_EDIT_STATE,
  SET_UPDATED_COMPANY,
} from './actionTypes';

import {STORE} from 'appredux/index';
import {
  ISupplierUserProfile,
  IPanelTypeInformation,
  IFarmInputProduct,
  IFarmInputProductDepotInfo,
  IFarmInputProductSubSubCategory,
  IDepot,
  IFarmInputQuote,
  IFarmInputInvoice,
  INotification,
  IFarmInputPurchaseOrder,
  IGenericType,
  IFarmInputProgramInput,
  IFarmInputProgramLineInput,
  IFdOperatingCost,
  ISupplierCompanyProfile,
} from 'constants/interfaces';
import AuthenticatedUserService from 'services/AuthenticatedUserService';
import {IGridItem} from './reducers/reducer-dashboard-widgets';
import type {WdgId} from 'screens/Dashboard/Overview/widgets';

import {PresetRange} from './reducers/reducer-date-filter';

export function reduxClearAll() {
  reduxSetUser(undefined);
  reduxSetProducts([]);
  reduxSetProductDepotInfos([]);
  reduxSetSubSubCategories([]);
  reduxSetDepots([]);
  reduxSetQuotes([]);
  reduxSetInvoices([]);
  reduxSetProformaInvoices([]);
  reduxSetPurchaseOrders([]);
  reduxSetPurchaseOrderStatuses([]);
  reduxSetNotifications([]);
}

export function reduxSetUser(payload?: ISupplierUserProfile | any) {
  AuthenticatedUserService.setUser(payload);
  return STORE.dispatch({
    type: SET_USER,
    payload: payload ? payload : {},
  });
}

export function reduxToggleSidePanel(
  open: boolean,
  panelInfo?: IPanelTypeInformation | null,
  withoutOverlay?: boolean,
) {
  return STORE.dispatch({
    type: SET_PANEL_OPEN,
    payload: {
      open,
      panelInfo,
      withoutOverlay,
    },
  });
}

export function reduxSetSidePanelEditState(
  state: 'idle' | 'editing' | 'saved',
) {
  return STORE.dispatch({
    type: SET_PANEL_EDIT_STATE,
    payload: state,
  });
}

export function reduxSetProducts(products: IFarmInputProduct[]) {
  return STORE.dispatch({
    type: SET_PRODUCTS,
    payload: products,
  });
}

export function reduxUpdateProduct(product: IFarmInputProduct) {
  return STORE.dispatch({
    type: UPDATE_PRODUCT,
    payload: product,
  });
}

export function reduxAddProduct(product: IFarmInputProduct) {
  return STORE.dispatch({
    type: ADD_PRODUCT,
    payload: product,
  });
}

export function reduxSetProductDepotInfos(
  productDepotInfos: IFarmInputProductDepotInfo[],
) {
  return STORE.dispatch({
    type: SET_PRODUCT_DEPOT_INFOS,
    payload: productDepotInfos,
  });
}

export function reduxUpdateProductDepotInfo(
  productDepotInfos: IFarmInputProductDepotInfo[],
) {
  return STORE.dispatch({
    type: UPDATE_PRODUCT_DEPOT_INFOS,
    payload: productDepotInfos,
  });
}

export function reduxSetSubSubCategories(
  subSubCategories: IFarmInputProductSubSubCategory[],
) {
  return STORE.dispatch({
    type: SET_SUB_SUB_CATEGORIES,
    payload: subSubCategories,
  });
}

export function reduxSetDepots(depots: IDepot[]) {
  return STORE.dispatch({
    type: SET_DEPOTS,
    payload: depots,
  });
}

export function reduxUpdateDepot(depot: IDepot) {
  return STORE.dispatch({
    type: UPDATE_DEPOT,
    payload: depot,
  });
}

export function reduxAddDepot(depot: IDepot) {
  return STORE.dispatch({
    type: ADD_DEPOT,
    payload: depot,
  });
}

export function reduxSetQuotes(quotes: IFarmInputQuote[]) {
  return STORE.dispatch({
    type: SET_QUOTES,
    payload: quotes,
  });
}

export function reduxUpdateQuote(quote: IFarmInputQuote) {
  return STORE.dispatch({
    type: UPDATE_QUOTE,
    payload: quote,
  });
}

export function reduxRemoveQuote(quoteId: string) {
  return STORE.dispatch({
    type: REMOVE_QUOTE,
    payload: quoteId,
  });
}

export function reduxAddQuote(quote: IFarmInputQuote) {
  return STORE.dispatch({
    type: ADD_QUOTE,
    payload: quote,
  });
}

export function reduxSetInvoices(invoices: IFarmInputInvoice[]) {
  return STORE.dispatch({
    type: SET_INVOICES,
    payload: invoices,
  });
}

export function reduxUpdateInvoice(invoice: IFarmInputInvoice) {
  return STORE.dispatch({
    type: UPDATE_INVOICE,
    payload: invoice,
  });
}

export function reduxAddInvoice(invoice: IFarmInputInvoice) {
  return STORE.dispatch({
    type: ADD_INVOICE,
    payload: invoice,
  });
}

export function reduxSetProformaInvoices(invoices: IFarmInputInvoice[]) {
  return STORE.dispatch({
    type: SET_PROFORMA_INVOICES,
    payload: invoices,
  });
}

export function reduxUpdateProformaInvoice(invoice: IFarmInputInvoice) {
  return STORE.dispatch({
    type: UPDATE_PROFORMA_INVOICE,
    payload: invoice,
  });
}

export function reduxSetPurchaseOrders(
  purchaseOrders: IFarmInputPurchaseOrder[],
) {
  return STORE.dispatch({
    type: SET_PURCHASE_ORDERS,
    payload: purchaseOrders,
  });
}

export function reduxUpdatePurchaseOrder(
  purchaseOrder: IFarmInputPurchaseOrder,
) {
  return STORE.dispatch({
    type: UPDATE_PURCHASE_ORDER,
    payload: purchaseOrder,
  });
}

export function reduxAddPurchaseOrder(purchaseOrder: IFarmInputPurchaseOrder) {
  return STORE.dispatch({
    type: ADD_PURCHASE_ORDER,
    payload: purchaseOrder,
  });
}

export function reduxSetPurchaseOrderStatuses(
  purchaseOrderStatuses: IGenericType[],
) {
  return STORE.dispatch({
    type: SET_PURCHASE_ORDER_STATUSES,
    payload: purchaseOrderStatuses,
  });
}

export function reduxSetNotifications(notifications: INotification[]) {
  return STORE.dispatch({
    type: SET_NOTIFICATIONS,
    payload: notifications,
  });
}

export function reduxUpdateNotification(notification: INotification) {
  return STORE.dispatch({
    type: UPDATE_NOTIFICATION,
    payload: notification,
  });
}

export function reduxAddNotification(notification: INotification) {
  return STORE.dispatch({
    type: ADD_NOTIFICATION,
    payload: notification,
  });
}

export function reduxClearCreateProgram() {
  return STORE.dispatch({
    type: CLEAR_CREATE_PROGRAM,
  });
}

export function reduxSetCreateProgram(program: IFarmInputProgramInput) {
  return STORE.dispatch({
    type: SET_CREATE_PROGRAM_PROGRAM,
    payload: program,
  });
}

export function reduxAddCreateProgramLine(
  programLine: IFarmInputProgramLineInput,
) {
  return STORE.dispatch({
    type: ADD_CREATE_PROGRAM_LINE,
    payload: programLine,
  });
}

export function reduxUpdateCreateProgramLine(
  programLine: IFarmInputProgramLineInput,
  index: number,
) {
  return STORE.dispatch({
    type: UPDATE_CREATE_PROGRAM_LINE,
    payload: {data: programLine, index},
  });
}

export function reduxRemoveCreateProgramLine(index: number) {
  return STORE.dispatch({
    type: REMOVE_CREATE_PROGRAM_LINE,
    payload: {index},
  });
}

export function reduxMoveCreateProgramLineUp(index: number) {
  return STORE.dispatch({
    type: MOVE_CREATE_PROGRAM_LINE_UP,
    payload: {index},
  });
}

export function reduxMoveCreateProgramLineDown(index: number) {
  return STORE.dispatch({
    type: MOVE_CREATE_PROGRAM_LINE_DOWN,
    payload: {index},
  });
}

export function reduxSetProgramsList(programs: IFarmInputProgramInput[]) {
  return STORE.dispatch({
    type: SET_PROGRAMS_LIST,
    payload: programs,
  });
}

export function reduxAddProgram(program: IFarmInputProgramInput) {
  return STORE.dispatch({
    type: ADD_PROGRAM,
    payload: program,
  });
}

export function reduxUpdateProgram(program: IFarmInputProgramInput) {
  return STORE.dispatch({
    type: UPDATE_PROGRAM,
    payload: program,
  });
}

export function reduxRemoveProgram(programId: string | number) {
  return STORE.dispatch({
    type: REMOVE_PROGRAM,
    payload: programId,
  });
}

export function reduxSetApplicationsList(applications: any[]) {
  return STORE.dispatch({
    type: SET_APPLICATIONS_LIST,
    payload: applications,
  });
}

export function reduxAddApplication(application: any) {
  return STORE.dispatch({
    type: ADD_APPLICATION,
    payload: application,
  });
}

export function reduxUpdateApplication(application: any) {
  return STORE.dispatch({
    type: UPDATE_APPLICATION,
    payload: application,
  });
}

export function reduxSetCurrentApplication(applicationId: string) {
  return STORE.dispatch({
    type: SET_CURRENT_APPLICATION,
    payload: applicationId,
  });
}
export const rdwSetWidgetLayout = (l: IGridItem[]) => ({
  type: RDW_SET_LAYOUT,
  payload: l,
});

export const rdwUpdateWidgetSize = (id: WdgId, w: 4 | 5 | 9) => ({
  type: RDW_UPDATE_SIZE,
  payload: {id, w},
});

/* helpers */
export const rdwAddWidget = (
  id: WdgId,
): {type: typeof RDW_ADD_WIDGET; payload: WdgId} => ({
  type: RDW_ADD_WIDGET,
  payload: id,
});

export const rdwRemoveWidget = (
  id: WdgId,
): {type: typeof RDW_REMOVE_WIDGET; payload: WdgId} => ({
  type: RDW_REMOVE_WIDGET,
  payload: id,
});

export function reduxSetPresetDateRange(preset: PresetRange) {
  return STORE.dispatch({
    type: DF_SET_PRESET_RANGE,
    payload: preset,
  });
}

export function reduxSetCustomDateRange(start: Date, end: Date) {
  return STORE.dispatch({
    type: DF_SET_CUSTOM_RANGE,
    payload: {start, end},
  });
}

/* ───────── Operating Costs (Applications) ───────── */
export function reduxSetOperatingCosts(rows: IFdOperatingCost[]) {
  return STORE.dispatch({
    type: SET_OPERATING_COSTS,
    payload: rows,
  });
}

export function reduxAddOperatingCost(row: IFdOperatingCost) {
  return STORE.dispatch({
    type: ADD_OPERATING_COST,
    payload: row,
  });
}

export function reduxUpdateOperatingCost(row: IFdOperatingCost) {
  return STORE.dispatch({
    type: UPDATE_OPERATING_COST,
    payload: row,
  });
}

export function reduxRemoveOperatingCost(id: number | string) {
  return STORE.dispatch({
    type: REMOVE_OPERATING_COST,
    payload: id,
  });
}

export function reduxSetUpdatedCompany(company?: ISupplierCompanyProfile) {
  return STORE.dispatch({
    type: SET_UPDATED_COMPANY,
    payload: company,
  });
}
